import { ValidatingInput, InputComponentProps } from '~/components/validating-input';

export const NameOnDocument = (props: InputComponentProps) => {
  const validate = ({ value }) => {
    const regex = /^[a-zA-ZÀ-ÖØ-öø-ÿ' -]+$/;
    if (value.trim().length < 1) return 'Please enter your name on document';
    if (!regex.test(value.trim())) return 'Please enter a valid name';

    return true;
  };

  return (
    <ValidatingInput
      label="Name on document(s)"
      name="nameOnDocument"
      placeholder="Name on document(s)"
      validate={validate}
      {...props}
    />
  );
};
